import cn from 'classnames';
import type { FC} from 'react';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useNavigate, useParams } from 'react-router-dom';

import { useCheckout } from '@pages/cart/model';

import { MediumHeader, MediumModal } from '@shared/ui';

import { Spinner } from 'library/components/shop';
import usePromocode from 'library/hooks/shop/usePromocode';
import { Product } from 'library/models/shop';

import * as st from './styles.module.scss';

type Props = {
	toggleModal: any;
	recommend: string;
	productTitle: string;
};

export const RecommendModal: FC<Props> = ({ productTitle, recommend, toggleModal }) => {
	const [copied, setCopied] = useState(false);
	const { code, status } = usePromocode();

	const checkout = useCheckout();

	const isPartner = checkout.isPartner;

	const params = useParams<{ code: string }>();

	const onCopy = () => {
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 1000);
	};

	const recommendUrl = `${window.location.origin}${recommend}`;

	return (
		<MediumModal isOpen onRequestClose={() => toggleModal(false)}>
			<MediumHeader title="Рекомендация товара" onClose={() => toggleModal(false)} />

			{status === 'loading' && (
				<div className={st.loader}>
					<Spinner />
				</div>
			)}

			{status === 'loaded' && (
				<div className={st.content}>
					<h3 className={st.content__note}>
						При покупке товаров в нашем интернет - магазине с использованием Вашего промокода
						покупатель получает скидку, а Вы вознаграждение.
					</h3>

					<section className={st.content__data}>
						{/* <div className={st.content__title}>Сообщение</div> */}
						<div className={st.content__wrapper}>
							<p>
								Рекомендую Вам для приобретения
								<br></br>
								<span>
									<b>«{productTitle}»</b>
								</span>
							</p>
							<br></br>
							<p>
								Ссылка на товар: 👉 <a href={recommendUrl}>{recommendUrl}</a>
							</p>
							<br></br>
							{isPartner && (
								<>
									<p>
										Также Вы можете воспользоваться моей <b>персональной скидкой</b> 👇
									</p>
									<br></br>
									<p>
										При оформлении товара введите промокод:{' '}
										<span>
											<b>{code}</b>
										</span>
									</p>
								</>
							)}
						</div>
					</section>

					<section className={st.submit}>
						<CopyToClipboard
							text={
								isPartner
									? `Рекомендую вам для приобретения\n  ${productTitle} \n 
Ссылка на товар: 👉 ${recommendUrl} \n 
Также вы можете воспользоваться моей персональной скидкой 👇 \n 
При оформлении товара введите промокод: ${code}`
									: `Рекомендую вам для приобретения\n  ${productTitle} \n 
Ссылка на товар: 👉 ${recommendUrl}`
							}
							onCopy={onCopy}
						>
							<button>Скопировать</button>
						</CopyToClipboard>
					</section>
				</div>
			)}

			<div className={cn(st.message, copied && st.visible)}>Скопировано в буфер обмена</div>
		</MediumModal>
	);
};
